import { Link } from 'react-router-dom';
import { Scale } from 'lucide-react';
import PublicLayout from '@/components/PublicLayout';

export default function Terms() {
  return (
    <PublicLayout>
      <main className="pt-20 pb-14 lg:pt-28 lg:pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-slate-200/80 shadow-sm p-8 lg:p-10">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900 tracking-tight">
                  Terms of Service
                </h1>
                <p className="text-slate-600 mt-2">
                  Last updated: {new Date().toLocaleDateString()}
                </p>
              </div>
              <div className="hidden sm:flex w-12 h-12 rounded-xl bg-slate-100 items-center justify-center">
                <Scale className="w-6 h-6 text-slate-700" />
              </div>
            </div>

            <div className="prose prose-slate max-w-none">
              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">1. Agreement to Terms</h2>
                <p className="text-slate-600 leading-relaxed">
                  By accessing or using Hoito&apos;s services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">2. Use License</h2>
                <p className="text-slate-600 mb-4 leading-relaxed">
                  Permission is granted to temporarily access and use our services for personal, non-commercial purposes. This license does not include:
                </p>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>Modifying or copying our materials</li>
                  <li>Using materials for commercial purposes</li>
                  <li>Attempting to reverse engineer any software</li>
                  <li>Removing any copyright or proprietary notations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">3. Account Terms</h2>
                <ul className="list-disc pl-6 mb-4 text-slate-600 space-y-1">
                  <li>You must be 18 years or older to use this service</li>
                  <li>You must provide accurate and complete information</li>
                  <li>You are responsible for maintaining account security</li>
                  <li>You must notify us of any security breaches</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">4. Service Modifications</h2>
                <p className="text-slate-600 leading-relaxed">
                  We reserve the right to modify or discontinue our service at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">5. Limitation of Liability</h2>
                <p className="text-slate-600 leading-relaxed">
                  We shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our services.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-lg font-semibold text-slate-900 mb-4">6. Governing Law</h2>
                <p className="text-slate-600 leading-relaxed">
                  These terms shall be governed by and construed in accordance with the laws of the jurisdiction in which we operate, without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-slate-900 mb-4">7. Contact Information</h2>
                <p className="text-slate-600 leading-relaxed">
                  Questions about the Terms of Service should be sent to:
                  <br />
                  <a href="mailto:hello@hoitodigital.com" className="text-brand-900 hover:text-brand-800 font-medium">
                    hello@hoitodigital.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </PublicLayout>
  );
}
